import { Box, Link, Stack, Tooltip, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { clientConfigFieldsAtom } from '../../../../../services/state/AppConfigStateJ';
import { universalAndSystemKPIAtom } from '../../../../../services/state/KPIConfigState';

const tooltipContentSx = { maxHeight: '300px', overflowY: 'auto', p: 1 };

function UniversalKpiTooltip() {
  const universalKpis = useAtomValue(universalAndSystemKPIAtom);

  const kpiNames = useMemo(() => universalKpis.map((kpi) => kpi.displayName).sort(), [universalKpis]);

  return (
    <Box sx={tooltipContentSx}>
      <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mb: 1 }}>
        {
          "Foresight's Universal KPIs are a standardized set of financial metrics sourced from your portfolio companies' Income Statements, Balance Sheets, Cash Flow Statements, and Board Decks."
        }
      </Typography>
      <Typography
        variant='caption'
        color='text.secondary'
        sx={{ display: 'block', mb: 0.5 }}
        fontWeight={600}
      >
        Included KPIs:
      </Typography>
      <Stack component='ul' sx={{ m: 0, pl: 2 }}>
        {kpiNames.map((name) => (
          <Typography key={name} component='li' variant='caption' color='text.secondary'>
            {name}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}

function InfoBoxMessage() {
  return (
    <Typography variant='body2' component='span'>
      When reporting is enabled and respondents are configured, all portfolio companies will automatically
      receive quarterly{' '}
      <Tooltip title={<UniversalKpiTooltip />} placement='bottom-start' arrow leaveDelay={500}>
        <Link component='span' underline='always' color='text.primary'>
          Universal KPI
        </Link>
      </Tooltip>{' '}
      requests (30 days after quarter-end). To collect additional data beyond Universal KPIs, assign a request
      template to the relevant portfolio company.
    </Typography>
  );
}

export function ConsolidatedCompaniesInfoBox() {
  const isConsolidated =
    (useAtomValue(clientConfigFieldsAtom)?.Using_Consolidated_Data_Collection as boolean) ?? false;

  if (!isConsolidated) {
    return null;
  }

  return (
    <Stack pt={3}>
      <InfoBoxMessage />
    </Stack>
  );
}
